export default [
  {
    path: '/data-overview',
    name: 'dataOverview',
    component: () => import('../views/data-overview/List.vue')
  }
]
